import React, { useEffect, useState } from "react";
import { Drawer, Button, Popover, Tooltip } from "antd";
import {
  LogoutOutlined,
  MenuOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import "./navbar.css";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import FileList from "../content/FileList";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/user";
import { lastDoc } from "../../constants";
import ModalLogout from "../modal/ModalLogout";
import logoImg from "./logo";

const content = (
  <div className="spec-div">
    <FileList />
  </div>
);

// verde: incarcat in ultimele 24h; gri: normal; rosu: mai vechi de 30 de zile
const freshness = (date) => {
  if (!date) return "bad";
  const hours = moment().diff(moment(date), "hour");
  if (hours < 24) return "good";
  if (hours < 24 * 30) return "neutral";
  return "bad";
};

const FileChip = ({ label, doc }) => (
  <Tooltip
    title={
      doc
        ? `${doc.name} — încărcat ${moment(doc.createdAt).fromNow()} (${moment(doc.createdAt).format("DD.MM.YYYY, HH:mm")})`
        : "Nu există încă niciun fișier încărcat"
    }
  >
    <div className="nav-file-chip">
      <span className="nav-file-chip-top">
        <span className={`nav-file-dot nav-file-dot-${freshness(doc?.createdAt)}`} />
        {label}
      </span>
      <span className="nav-file-name">{doc ? doc.name : "—"}</span>
      <span className="nav-file-date">
        {doc ? moment(doc.createdAt).format("DD.MM.YYYY, HH:mm") : "fără fișier"}
      </span>
    </div>
  </Tooltip>
);

const NavBar = ({ menu }) => {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [docs, setDocs] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    async function getDocs() {
      try {
        const res = await lastDoc();
        setDocs(res.data || []);
      } catch (error) {
        console.log(error);
      }
    }
    getDocs();
    // reimprospatare din cand in cand, fisierele se incarca pe parcursul zilei
    const interval = setInterval(getDocs, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const indiceDoc = docs.find((d) => d.type === "indice");
  const platiDoc = docs.find((d) => d.type === "plati");

  const onLogout = () => {
    try {
      dispatch(logout());
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <nav className="navbar">
      <Button
        className="menu"
        type="primary"
        icon={<MenuOutlined />}
        onClick={() => setVisible(true)}
      ></Button>
      <Drawer
        title="Topics"
        placement="left"
        onClick={() => setVisible(false)}
        onClose={() => setVisible(false)}
        open={visible}
      >
        {menu}
      </Drawer>
      <div className="d-flex align-items-center justify-content-between">
        <Link to="/">
          <img src={logoImg} className="logo" alt="logo" />
        </Link>
        <div className="mx-3 text-end d-flex gap-3 justify-content-end align-items-center">
          <span className="nav-files">
            <FileChip label="Ultimul fișier indici" doc={indiceDoc} />
            <FileChip label="Ultimul fișier plăți" doc={platiDoc} />
          </span>

          <Popover placement="bottomRight" content={content} trigger={"click"}>
            <Button
              className="nav-files-btn"
              type="primary"
              shape="circle"
              icon={<ProfileOutlined />}
            />
          </Popover>

          <Button
            type="primary"
            shape="circle"
            icon={<LogoutOutlined />}
            onClick={() => setOpen(true)}
          />
        </div>
        <ModalLogout
          handleClose={() => setOpen(false)}
          handleOk={onLogout}
          open={open}
        />
      </div>
    </nav>
  );
};
export default NavBar;
